import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 15.75, height: 10.5, viewBox: "0 0 19 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.25 1.81641L6.75 12.3164L1.5 7.06641", stroke: "#36B368", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgIcCheck);
const Memo = memo(ForwardRef);
export default Memo;
